import { TimeTrial } from '../EnumTypes/ActionEnumTypes';
import { addTimeTrial as addTimeTrialConnector } from 'Connectors/TimeTrialConnector';
import * as ViewManagementModule from 'Modules/ViewManagementModule';
import { toast } from 'react-toastify';
import { ROUTES } from 'shared/consts';
import { history } from 'Store/Reducers/RootReducer';

const init = () => ({
  type: TimeTrial.ADD_TIME_TRIAL_INIT,
});

const success = (timeTrialList) => ({
  type: TimeTrial.ADD_TIME_TRIAL_SUCCESS,
  payload: {
    timeTrialList,
  },
});

const failure = () => ({
  type: TimeTrial.ADD_TIME_TRIAL_FAILURE,
});

const addTimeTrial = (timeTrialData) => async (dispatch) => {
  dispatch(init());
  try {
    dispatch(ViewManagementModule.Actions.showLoader());
    const { data } = await addTimeTrialConnector({ timeEntryCreationDto: { ...timeTrialData } });
    dispatch(success(data));
    toast.success('Pomyślnie dodano czasówkę');
    dispatch(ViewManagementModule.Actions.hideLoader());
    history.push(ROUTES.TIME_TRIAL_LIST);
  } catch (err) {
    dispatch(ViewManagementModule.Actions.hideLoader());
    toast.error('Nie udało się dodać czasówki');
    dispatch(failure());
  }
};

export default addTimeTrial;
